import { DailyVideo, useVideoTrack } from '@daily-co/daily-react';
import { useMemo } from 'react';
import useParticipantsWithHost from '../../hooks/useParticipantsWithHost';
import useWSTurnState from '../../hooks/useWSTurnState';
import { shouldPlayerBeMuted } from '../../utils/muteRules';
import Username from '../Username/Username';
import './Tile.css';

export default function Tile({ id, isScreenShare, isLocal, isAlone, empty }) {
  // Sempre chamar hooks no topo, antes de qualquer return condicional
  const { currentPhase, lastCompleter } = useWSTurnState();
  const { participantA, participantB } = useParticipantsWithHost();
  const videoState = useVideoTrack(id);

  // Identifica o role do participante (A ou B)
  const participantRole = useMemo(() => {
    if (participantA?.session_id === id) return 'A';
    if (participantB?.session_id === id) return 'B';
    return null;
  }, [id, participantA, participantB]);

  // Calcula se deve estar mutado baseado no turn state
  const shouldBeMutedByTurnState = useMemo(() => {
    if (!participantRole) return false;

    const currentState = {
      phase: currentPhase,
      lastCompleter
    };

    return shouldPlayerBeMuted(currentState, participantRole);
  }, [currentPhase, lastCompleter, participantRole]);

  // Usa a prop toBeMuted se fornecida, senão usa a lógica do turn state
  const finalToBeMuted = shouldBeMutedByTurnState;

  if (empty) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 'min(25vw, 30vh)' }}>
        <div className="tile-video no-video">
          <span style={{ color: '#aaa', fontSize: 'min(2.5vw, 3vh)' }}>waiting...</span>
        </div>
        <div className="username" style={{ color: '#aaa' }}>waiting...</div>
      </div>
    );
  }

  let containerCssClasses = isScreenShare ? 'tile-screenshare' : 'tile-video';

  if (isLocal) {
    containerCssClasses += ' self-view';
    if (isAlone) {
      containerCssClasses += ' alone';
    }
  }

  /* If a participant's video is muted, hide their video and
  add a different background color to their tile. */
  if (videoState.isOff) {
    containerCssClasses += ' no-video';
  }

  if (!finalToBeMuted) {
    containerCssClasses += ' yellow-border';
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 'min(25vw, 300px)' }}>
      <div className={containerCssClasses}>
        <DailyVideo automirror sessionId={id} type={isScreenShare ? 'screenVideo' : 'video'} />
         <div style={{ position: 'absolute', bottom: 30, left: "50%",
       transform: "translateX(-50%)"}}>
           {finalToBeMuted && (
             <svg
               aria-hidden="true"
               width="35"
               height="35"
               viewBox="0 0 24 24"
               fill="none"
               xmlns="http://www.w3.org/2000/svg"
               style={{ color: 'white' }}
             >
               <path
                 d="M12 3C13.5979 3 14.904 4.24928 14.9949 5.8244L9 11.8193V6C9 4.34315 10.3431 3 12 3Z"
                 fill="white"
               />
               <path
                 d="M15 10.0607L20.5303 4.53033C20.8232 4.23744 20.8232 3.76256 20.5303 3.46967C20.2374 3.17678 19.7626 3.17678 19.4697 3.46967L3.46967 19.4697C3.17678 19.7626 3.17678 20.2374 3.46967 20.5303C3.76256 20.8232 4.23744 20.8232 4.53033 20.5303L8.19557 16.8651C9.05938 17.5005 10.1108 17.8583 11.25 17.9654V20.25C11.25 20.6642 11.5858 21 12 21C12.4142 21 12.75 20.6642 12.75 20.25V17.9654C14.0989 17.8386 15.3247 17.3603 16.2617 16.4858C17.3784 15.4436 18 13.9175 18 12C18 11.5858 17.6642 11.25 17.25 11.25C16.8358 11.25 16.5 11.5858 16.5 12C16.5 13.5825 15.9966 14.6814 15.2383 15.3892C14.4713 16.105 13.3583 16.5 12 16.5C10.919 16.5 9.9933 16.2498 9.27382 15.7868L10.476 14.5846C10.9227 14.8486 11.4436 15 12 15C13.6569 15 15 13.6569 15 12V10.0607Z"
                 fill="white"
               />
               <path
                 d="M7.6111 13.2082C7.53881 12.8415 7.5 12.4394 7.5 12C7.5 11.5858 7.16421 11.25 6.75 11.25C6.33579 11.25 6 11.5858 6 12C6 12.8969 6.13599 13.7082 6.39503 14.4243L7.6111 13.2082Z"
                 fill="white"
               />
             </svg>
           )}
         </div>
      </div>
      {!isScreenShare && <Username id={id} isLocal={isLocal} />}
    </div>
  );
}
